module.exports = __webpack_public_path__ + "img/prospects-wealth-20.4d7ad5d4.jpg";